__turbopack_context__.v({
  "OfficesResults": "OfficesResults-module-scss-module__QB8g9G__OfficesResults",
});
